import { clash, satoshi } from '@/lib/fonts';
import { Tagline } from '@/app/(site)/(marketing)/_components/tagline';

// Shared frame for the focused lander pages (/r, /receive, /play) and the
// 404/error pages: dark brand background, Satoshi/Clash, a centered logo,
// then page content. `tagline` shows the marketing line — on by default for
// landers, off for utility pages. No glows — matches the DESIGN.md pages.
export function LanderShell({
  children,
  tagline = true,
}: {
  children: React.ReactNode;
  tagline?: boolean;
}) {
  return (
    <div
      className={`${satoshi.variable} ${clash.variable} bnk-page flex min-h-screen flex-col bg-bnk-bg font-satoshi text-bnk-text antialiased`}
    >
      <main className="flex flex-1 flex-col items-center justify-center px-6 pb-[calc(3rem+env(safe-area-inset-bottom))] pt-[calc(3rem+env(safe-area-inset-top))] text-center">
        <div className="flex w-full max-w-sm flex-col items-center gap-6">
          {/* eslint-disable-next-line @next/next/no-img-element -- SVG logo, no optimization needed */}
          <img
            src="/images/bankroll-logo.svg"
            alt="Bankroll"
            width={2000}
            height={255}
            className="h-auto w-[min(52vw,240px)]"
          />
          {tagline && <Tagline rules="fixed" />}
          {children}
        </div>
      </main>
    </div>
  );
}
